import uniqueId from '@/utils/uniqueId';

export default {
	created() {
		this.setEventListeners();
	},
	data() {
		return {
			errorMessageArray: [],
			componentUniqueId: undefined
		};
	},
	props: {
		/**
		 * One or more validators to run on the component's value
		 */
		validators: {
			type: [Object, Array],
			default: undefined
		},
		errors: {
			type: Array,
			default: () => []
		}
	},
	computed: {
		errorMessages() {
			return this.errorMessageArray || [];
		},
		validatorArray() {
			let vArray = this.validators;

			if (vArray && !Array.isArray(vArray)) {
				vArray = [vArray];
			}

			return vArray;
		},
		hasError() {
			return this.errorMessages.length > 0;
		}
	},
	methods: {
		setEventListeners() {
			if (this.validatorArray && this.validatorArray.length > 0) {
				this.validatorArray.forEach(v => {
					this.$on(v.validateOn, this.validate);
				});
			}
		},
		triggerValidation() {
			this.validate(this.value);
		},
		validate(value) {
			const result = {
				componentUniqueId: uniqueId('dms_'),
				valid: true,
				messages: []
			};
			let messages;

			if (this.validatorArray && this.validatorArray.length > 0) {
				this.validatorArray.forEach(v => {
					const result = v.validate(value, this.options);

					if (!result.valid) {
						if (!messages) {
							messages = [];
						}
						messages.push(...result.messages);
					}
				});

				if (messages && messages.length > 0) {
					this.errorMessageArray = messages;

					result.valid = false;
					result.messages = messages;
				} else {
					this.errorMessageArray = [];
				}

				this.$emit('validate', result);
			}
		}
	}
};
